import { makeAutoObservable } from 'mobx';
import { resetAllStore } from '../../shared/stores/resetAllStore';

import { preCheckInService } from '../services/preCheckInService';
import { ChildInformation } from '../interfaces/ChildInformation';

class ChildInformationStore {
  childInformation: ChildInformation = {
    connectedAccountID: '',
    fullName: '',
    dob: '',
    kidEmail: '',
    phone: '',
    stripePublicKey: '',
    subscriptions: {
      stripe: false,
      subscriptions: [],
      tax: 0,
    },
  };

  paymentMethodId = '';
  isEntityWithStripe = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues(): void {
    this.childInformation = {
      connectedAccountID: '',
      fullName: '',
      dob: '',
      kidEmail: '',
      phone: '',
      stripePublicKey: '',
      subscriptions: {
        stripe: false,
        subscriptions: [],
        tax: 0,
      },
    };
    this.paymentMethodId = '';
    this.isEntityWithStripe = false;
  }

  async loadChildInfo(): Promise<void> {
    const childInfo = await preCheckInService.getChildInfo();
    this.onSetChildInformation(childInfo);
    this.setIsEntityWithStripe();
  }

  onSetChildInformation(child: ChildInformation): void {
    this.childInformation = child;
  }

  savePaymentMethodId(paymentMethodId: string): void {
    this.paymentMethodId = paymentMethodId;
  }

  setIsEntityWithStripe(): void {
    this.isEntityWithStripe = !!this.childInformation.connectedAccountID;
  }
}

const childInformationStore = new ChildInformationStore();

resetAllStore.addResetMethod(childInformationStore.setDefaultValues);

export { childInformationStore, ChildInformationStore };
